exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirmation-modal .modal-body{-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start;display:flex;flex-flow:row wrap}.confirmation-modal .modal-body .confirm-message{flex:0 0 auto;width:calc(99.99% * 6/10 - 8px);text-align:left}.confirmation-modal .modal-body .confirm-message:nth-child(1n){margin-right:20px}.confirmation-modal .modal-body .confirm-message:last-child{margin-right:0}.confirmation-modal .modal-body .confirm-message:nth-child(10n){float:right;margin-right:0}.confirmation-modal .modal-body .button-group{flex:0 0 auto;width:calc(99.99% * 4/10 - 12px)}.confirmation-modal .modal-body .button-group:nth-child(1n){margin-right:20px}.confirmation-modal .modal-body .button-group:last-child{margin-right:0}.confirmation-modal .modal-body .button-group:nth-child(10n){float:right;margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/confirmation-modal/index.scss
// module id = 5238
// module chunks = 0